import {
  Modal,
  ModalContent,
  ModalTitle,
  useMuiModal,
} from "@/components/modal.tsx";
import { Trans } from "react-i18next";
import { Button } from "@/components/ui/button.tsx";
import { Link } from "@tanstack/react-router";
import { Machine } from "@/hooks/use-shop-details";
import { useAudioSlot } from "@/features/audio/kiosk-audio";

export const MachineSelectorModal = ({
  machineId,
  machineType,
  onAccept,
}: {
  machineId: number;
  machineType: Machine["machineType"];
  onAccept: () => void;
}) => {
  useAudioSlot(machineType === "mosogep" ? "modal.machine-selector.washer" : "modal.machine-selector.dryer");
  const { closeModal } = useMuiModal();
  return (
    <Modal>
      <ModalTitle>
        <Trans>Fontos!</Trans>
      </ModalTitle>
      <ModalContent>
        {machineType === "mosogep" ? (
          <>
            <p className={`leading-6`}>
              <Trans>
                Ne töltsd túl a gépet, mert előfordulhat, hogy NEM fogja
                kicentrifugázni!
              </Trans>
            </p>
            <p className={`leading-6`}>
              <Trans>
                Kérjük győződj meg arról, hogy kiválasztottad a mosógépen a
                programot és bezártad az ajtót, mielőtt a fizető automatához
                mész!
              </Trans>
            </p>
          </>
        ) : (
          <>
            <p className={`leading-6`}>
              <Trans>
                Ne töltsd túl a gépet, mert előfordulhat, hogy NEM szárít
                megfelelően!
              </Trans>
            </p>
            <p className={`leading-6`}>
              <Trans>
                Kérjük győződj meg arról, hogy kiválasztottad a szárítógépen a
                programot és bezártad az ajtót, mielőtt a fizető automatához
                mész!
              </Trans>
            </p>
          </>
        )}
        <div className={`flex gap-6`}>
          <Button onClick={closeModal} variant={`outline`}>
            <Trans>Vissza</Trans>
          </Button>
          <Button
            className={`px-2 w-max`}
            onClick={() => {
              onAccept();
              closeModal();
            }}
          >
            <Trans>Értettem, tovább</Trans>
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};
